import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FetchData from "../../providers/dataProvider";
import { formatDate } from "../../utils/Validate";

const ViewEnquiry = () => {
  const location = useLocation();
  const [viewItem, setViewItem] = useState(null);
  const navigate = useNavigate();
  const { data: currencyList } = FetchData("currency");
  const { data: productFamilyList } = FetchData("productfamily");
  const { data: assignedEngineerData} = FetchData("userprofile");

  useEffect(() => {
    if (location?.state) {
      const item = location?.state;
      const itemCopy = { ...item };
      const currencyObject = currencyList?.find(
        (el) => el?.id == item?.currencyId
      );
      if (currencyObject)
        itemCopy["currencyName"] = currencyObject?.currencyName;
      itemCopy["shortCode"] = currencyObject?.shortCode;
      itemCopy["dateStr"] = formatDate(item?.dueDate, "view");
      if (itemCopy) {
        itemCopy?.inquiryProducts?.map((obj) => {
          const documentObj = productFamilyList?.find(
            (el) => el?.id == obj?.productFamilyId
          );
          if (documentObj) obj["documentName"] = documentObj?.shortDesc;
          else obj["documentName"] = "";
          return obj;
        });
      }

      const assignObj = assignedEngineerData?.find(item => item?.identityId === itemCopy?.salesEngineerId)
      if (assignObj) itemCopy["assignTo"] = assignObj?.firstName + " " + assignObj?.lastName;

      const allocateObj = assignedEngineerData?.find(item => item?.identityId === itemCopy?.allocatedTo)
      if (allocateObj) itemCopy["allocateTo"] = allocateObj?.firstName + " " + allocateObj?.lastName;
      setViewItem(itemCopy);
    } else if (location?.state == null) {
      navigate("/dashboard");
    }
  }, [location?.state, currencyList, productFamilyList, assignedEngineerData]);

  return (
    <div className="container-fluid view-enquiry-sec">
      <section className="enquiry-view-sec mt-2">
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="card mb-2">
              <div className="card-header pl-3">
                <div class="d-flex justify-content-start align-items-center w-100 flex-wrap">
                  <Link to="/enquiry-list">
                    <button className="btn p-0 mr-2" type="button">
                      <i class="fas fa-angle-left"></i>
                    </button>
                  </Link>
                  <h1> General</h1>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Customer Name</h5>
                      <h6>{viewItem?.customerName}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Project Name</h5>
                      <h6>{viewItem?.projectName}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Customer Address</h5>
                      <h6>{viewItem?.customerAddress}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Customer Enquiry Reference</h5>
                      <h6>{viewItem?.inquiryRef}</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Enquiry Type</h5>
                      <h6>
                        {viewItem?.inquiryType == 1 ? "Job In Hand" : "Tender"}
                      </h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Enquiry Due Date</h5>
                      <h6>{viewItem?.dateStr}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Assigned Engineer</h5>
                      <h6>{viewItem?.assignTo}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Contact person</h5>
                      <h6>{viewItem?.contactPerson}</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Country</h5>
                      <h6>{viewItem?.countryName}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Distributor</h5>
                      <h6>{viewItem?.distributorName}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Phone Number</h5>
                      <h6>{viewItem?.mobileNo}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Email Address</h5>
                      <h6>{viewItem?.emailAddress}</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Allocated To</h5>
                      <h6>{viewItem?.allocateTo}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Currency</h5>
                      <h6>{viewItem?.shortCode}</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div>
                      <h5>Additional Info</h5>
                      <h6>{viewItem?.additionalInfo}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header pl-3">
                <h1>Upload specification and schedule</h1>
              </div>
              <div className="card-body px-3">
                <div className="row">
                  {viewItem?.inquiryProducts?.length > 0 ? (
                    viewItem?.inquiryProducts?.map((doc) => (
                      <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-12 mb-4 p-2">
                        <div className="uploaded-documents">
                          {doc?.attachmentUrl != "" && (
                            <i class="far fa-file-pdf"></i>
                          )}
                          <p>{doc?.documentName}</p>
                          <hr></hr>
                          <h6>{doc?.productNotes}</h6>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="px-2">No Files</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-4 mb-4">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="text-right mob-mt-13 mob-mb-15">
              <Link to="/enquiry-list">
                <button className="btn back-btn" type="button">
                  Back
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ViewEnquiry;
